import { ClickAwayListener, Modal } from '@material-ui/core';
import React from 'react';

type Props = {
  children: React.ReactElement;
  style?: React.CSSProperties;
  onClose: () => void;
};

export const InlineModal = ({ children, style, onClose }: Props): React.ReactElement => {
  return (
    <ClickAwayListener onClickAway={onClose}>
      {/* Use modal to capture Escape, and force focus to the selected field */}
      <Modal
        open
        hideBackdrop
        disablePortal
        onClose={onClose}
        style={{
          // Do not reposition the modal relative to the entire page
          position: 'unset',
          ...style,
        }}
      >
        {children}
      </Modal>
    </ClickAwayListener>
  );
};
